import { SyntheticEvent } from "react";
import { FieldRenderProps } from "react-final-form";

import { FinalFormSwitch } from "components/form/FinalFormSwitch";
import { EventPlace, trackEngagement } from "helpers/analytics";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const ShowPreviousMessagesSwitch = ({ input }: FieldRenderProps<string, HTMLInputElement>) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleChange = (event: SyntheticEvent) => {
    trackEngagement("Visual template editor: Content previous messages pressed", EventPlace.Settings, {
      previousValue: input.checked,
    });
    input.onChange(event);
  };
  const componentProps = {
    input: {
      ...input,
      onChange: handleChange,
    },
  } as unknown as FieldRenderProps<string, HTMLInputElement>;

  return <FinalFormSwitch {...componentProps} />;
};
